var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 22 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.999 12.025a1.1082 1.1082 0 0 0-1.1074 1.1074v8.084c-1.1076 0.44114-1.8926 1.5182-1.8926 2.7832 0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0-1.2642-0.78407-2.3396-1.8906-2.7812v-8.0859a1.1082 1.1082 0 0 0-1.1094-1.1074z"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.464 1.4645c0.9376-0.93769 2.2094-1.4645 3.5355-1.4645s2.5979 0.52678 3.5355 1.4645c0.9377 0.93768 1.4645 2.2094 1.4645 3.5355v12.792c0.8679 0.6799 1.584 1.5369 2.0994 2.5161 0.5995 1.139 0.9088 2.4082 0.9006 3.6952-9e-4 2.1205-0.8437 4.154-2.3431 5.6535-1.5003 1.5002-3.5352 2.3431-5.6569 2.3431s-4.1566-0.8429-5.6569-2.3431c-1.5002-1.5003-2.3431-3.5352-2.3431-5.6569v-0.0137c0.0175-1.2769 0.3367-2.5317 0.9315-3.6618 0.5123-0.9735 1.2167-1.8307 2.0685-2.5209v-12.804c0-1.3261 0.5268-2.5978 1.4645-3.5355zm3.5355 0.53553c-0.7956 0-1.5587 0.31607-2.1213 0.87868s-0.8787 1.3257-0.8787 2.1213v13.818l-0.4226 0.2989c-0.7853 0.5553-1.4281 1.2884-1.8761 2.1395-0.4468 0.849-0.6871 1.7915-0.7013 2.7508 0.0018 1.5889 0.6338 3.1122 1.7574 4.2358 1.1252 1.1253 2.6513 1.7574 4.2426 1.7574s3.1174-0.6321 4.2426-1.7574c1.1253-1.1252 1.7574-2.6513 1.7574-4.2426v-0.0068c0.0065-0.959-0.2238-1.9048-0.6704-2.7535-0.4467-0.8487-1.0959-1.574-1.8901-2.1116l-0.4395-0.2974v-13.831c0-0.79565-0.3161-1.5587-0.8787-2.1213s-1.3257-0.87868-2.1213-0.87868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 15c0-0.5523 0.44772-1 1-1h4c0.5523 0 1 0.4477 1 1s-0.4477 1-1 1h-4c-0.55228 0-1-0.4477-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 11c0 0.5523-0.4477 1-1 1h-1c-0.55228 0-1-0.4477-1-1s0.44772-1 1-1h1c0.5523 0 1 0.4477 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7c0-0.5523 0.44772-1 1-1h4c0.5523 0 1 0.4477 1 1s-0.4477 1-1 1h-4c-0.55228 0-1-0.4477-1-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.1b7300f906ccf849339c861d670a2992.svg";
export { ForwardRef as ReactComponent };